// strings.js

const strings = {
    STRIPE_DEV_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/test_aEU4hj4gZ8BH5mo3dn", // nammeh
    STRIPE_PROD_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/8wMfZR6RoaZE2sweW5", // nammeh

    STRIPE_SUBSCRIPTION_MANAGEMENT_URL: "https://billing.stripe.com/p/login/28ocP200L31J9gs7ss",
    SUBSCRIPTION_STATUS_API_URL: "https://funquiz.app/modular2/subscription-status",
    
    GENERIC_PAGE_TITLE: "Funky Art Gen AI 🎨",
    HOME_PAGE_TITLE: "Home - Funky Art Gen AI 🎨",
    DASHBOARD_PAGE_TITLE: "Home - Funky Art Gen AI 🎨",
    WELCOME_MESSAGE_H1_TITLE: "Welcome to Funky Art Gen AI 🎨",
    FX_DESCRIPTION_MESSAGE: "This f(x) can be used to generate funky style art, enter a prompt and then press the 'Submit Input' button below to get your result!",
    
    MAIN_API_NAME: "nammeh_art_gen_ai_1",
    MAIN_API_URL: "https://funquiz.app/modular2/nammeh-art-gen-ai-1",

    PROD_CLERK_PUB_KEY: "pk_live_Y2xlcmsueW9sbGVnLmNvbSQ",
    DEV_CLERK_PUB_KEY: "pk_test_aGFybWxlc3MtYmVlLTY5LmNsZXJrLmFjY291bnRzLmRldiQ",

    // ... add more strings as needed
};



export default strings;